import { combineURLs } from './combineURLs';
import { isAbsoluteUrl } from './isAbsoluteUrl';
/**
 * Creates a URL by combining a base URL with a relative or absolute requested URL.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL The requested URL
 *
 * @returns {string} The combined URL
 */
export function buildFullUrl(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteUrl(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
    }
    return requestedURL;
}
